(function () {
  const header = document.querySelector('[data-fd-global-header]');
  const hasGlobalHeader = Boolean(header);

  const miniCart = hasGlobalHeader ? header.querySelector('[data-fd-mini-cart]') : null;
  const miniCartContent = miniCart ? miniCart.querySelector('[data-fd-mini-cart-content]') : null;
  const routes = window.theme && window.theme.routes ? window.theme.routes : {};
  const cookieConsentKey = 'fdCookieConsent';
  const cookieConsentCookie = 'fd_cookie_consent';

  const route = (name, fallback) => routes[name] || fallback;

  const hasCookieConsent = () => {
    try {
      if (window.localStorage && window.localStorage.getItem(cookieConsentKey)) return true;
    } catch (error) {}

    try {
      return document.cookie.split(';').some((item) => item.trim().indexOf(`${cookieConsentCookie}=`) === 0);
    } catch (error) {
      return false;
    }
  };

  const storeCookieConsent = (choice) => {
    const value = encodeURIComponent(choice || 'dismissed');

    try {
      if (window.localStorage) window.localStorage.setItem(cookieConsentKey, value);
    } catch (error) {}

    try {
      document.cookie = `${cookieConsentCookie}=${value}; max-age=31536000; path=/; SameSite=Lax`;
    } catch (error) {}
  };

  const hideCookieBars = () => {
    document.querySelectorAll('[data-fd-cookie]').forEach((cookie) => {
      cookie.style.setProperty('display', 'none', 'important');
      cookie.hidden = true;
    });
  };

  const enableCookieBars = () => {
    document.querySelectorAll('[data-fd-cookie]').forEach((cookie) => {
      cookie.hidden = false;
      cookie.style.setProperty('display', 'grid', 'important');
      cookie.style.setProperty('z-index', '2147483000', 'important');
      cookie.style.setProperty('pointer-events', 'auto', 'important');

      cookie.querySelectorAll('button, a').forEach((control) => {
        control.style.setProperty('pointer-events', 'auto', 'important');
        control.style.position = 'relative';
        control.style.zIndex = '1';
      });
    });
  };

  const syncCookieBars = () => {
    if (hasCookieConsent()) {
      hideCookieBars();
    } else {
      enableCookieBars();
    }
  };

  syncCookieBars();
  document.addEventListener('DOMContentLoaded', syncCookieBars);
  window.addEventListener('load', syncCookieBars);
  window.setTimeout(syncCookieBars, 300);
  window.setTimeout(syncCookieBars, 1200);
  window.setTimeout(syncCookieBars, 3000);

  document.addEventListener('click', (event) => {
    const cookieClose = event.target && event.target.closest ? event.target.closest('[data-fd-cookie-close]') : null;
    if (!cookieClose) return;

    const choice = (cookieClose.textContent || 'dismissed').trim().toLowerCase().replace(/\s+/g, '-');
    storeCookieConsent(choice);
    hideCookieBars();
  }, true);

  if (!hasGlobalHeader) return;

  const syncProductHeaderOffset = () => {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    const height = Math.ceil(header.getBoundingClientRect().height || 0);
    if (height > 0) {
      document.documentElement.style.setProperty('--fd-product-sticky-header-height', `${height}px`);
    }
  };

  syncProductHeaderOffset();
  window.requestAnimationFrame(syncProductHeaderOffset);
  window.addEventListener('load', syncProductHeaderOffset, { once: true });
  window.addEventListener('resize', syncProductHeaderOffset);

  if (window.ResizeObserver) {
    const headerResizeObserver = new ResizeObserver(syncProductHeaderOffset);
    headerResizeObserver.observe(header);
  }

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const formatMoney = (cents) => {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.settings && window.theme.settings.moneyFormat);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  };

  const readJson = (response) => response.json().then((data) => {
    if (!response.ok || data.status === 422) {
      throw data;
    }
    return data;
  });

  const getCart = () => fetch(`${route('cart', '/cart.js')}?t=${Date.now()}`, {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' }
  }).then(readJson);

  const cartHasBcpoAddons = (cart) => Boolean(cart && Array.isArray(cart.items) && cart.items.some((item) => (
    item.properties && Object.keys(item.properties).some((key) => {
      const value = item.properties[key];
      return value && value.match && value.match(/ \| ([^|]+)$/);
    })
  )));

  const sendBcpoCheckout = (cart) => new Promise((resolve, reject) => {
    if (!window.bcpo || !window.bcpo.$ || !window.Shopify || !cartHasBcpoAddons(cart)) {
      reject(new Error('BCPO checkout is not available for this cart.'));
      return;
    }

    const bcpoApi = window.bcpo;
    const settings = window.bcpo_settings || {};
    const noteAttributes = bcpoApi.note_attributes || {};
    const tags = Array.isArray(bcpoApi.tags) ? bcpoApi.tags.join(', ') : '';
    const moneyFormat = typeof bcpoApi.getMoneyFormat === 'function' ? bcpoApi.getMoneyFormat() : '${{amount}}';

    bcpoApi.$.post('https://obscure-escarpment-2240.herokuapp.com/add-ons', {
      shop: window.Shopify.shop,
      cart,
      afDiscountObject: window.afDiscountObject,
      discountOnCartProApp: window.discountOnCartProApp ? window.discountOnCartProApp.integration : null,
      disallowDiscountCodesInCheckout: settings.disallowDiscountCodesInCheckout,
      selections: window.bcpoSelections,
      variant: window.bcpoVariant,
      note: '',
      note_attributes: noteAttributes,
      tags,
      currency: window.Shopify.currency && window.Shopify.currency.rate && window.Shopify.currency.active,
      rate: window.Shopify.currency && window.Shopify.currency.active && window.Shopify.currency.rate,
      shipping_address: bcpoApi.shipping_address,
      requires_shipping: settings.requires_shipping,
      money_format: moneyFormat,
      tax_price_addons: settings.tax_price_addons,
      langify: window.langify || window.TranslationLab ? 'on' : 'off',
      options_in_note: settings.options_in_note,
      shipping_title: settings.shipping_title,
      shipping_price: settings.shipping_price,
      properties_on_original: settings.properties_on_original,
      customer_id: window.__st && window.__st.cid ? `gid://shopify/Customer/${window.__st.cid}` : null
    }).done(resolve).fail(reject);
  });

  const submitCartCheckoutForm = (form) => {
    if (!form) return;

    if (!form.querySelector('input[name="checkout"]')) {
      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      form.appendChild(checkoutInput);
    }

    HTMLFormElement.prototype.submit.call(form);
  };

  const handleBcpoCheckoutClick = (event) => {
    const checkoutTarget = event.target && event.target.closest
      ? event.target.closest('[data-fd-mini-cart] a[href^="/checkout"], .fd-cart-panel a[href^="/checkout"], [data-fd-mini-cart] form.fd-cart-panel__checkout, .fd-cart-panel form.fd-cart-panel__checkout')
      : null;
    if (!checkoutTarget) return false;

    const checkoutForm = checkoutTarget.matches && checkoutTarget.matches('form')
      ? checkoutTarget
      : null;
    const checkoutLink = checkoutForm ? null : checkoutTarget;

    event.preventDefault();
    checkoutTarget.setAttribute('aria-busy', 'true');
    getCart()
      .then((cart) => {
        if (!cartHasBcpoAddons(cart)) {
          if (checkoutForm) {
            submitCartCheckoutForm(checkoutForm);
          } else {
            window.location.href = checkoutLink.href || '/checkout';
          }
          return null;
        }
        return sendBcpoCheckout(cart).then((url) => {
          window.location.href = url || '/checkout';
        });
      })
      .catch(() => {
        if (checkoutForm) {
          submitCartCheckoutForm(checkoutForm);
        } else {
          window.location.href = checkoutLink.href || '/checkout';
        }
      })
      .finally(() => {
        checkoutTarget.removeAttribute('aria-busy');
      });

    return true;
  };

  const changeCartItem = (key, quantity) => fetch(`${route('cartChange', '/cart/change.js')}?t=${Date.now()}`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: key,
      quantity: Math.max(parseInt(quantity, 10) || 0, 0)
    })
  }).then(readJson);

  const setBusy = (scope, isBusy) => {
    if (!scope) return;
    scope.classList.toggle('is-loading', isBusy);
    scope.querySelectorAll('button, input').forEach((control) => {
      control.disabled = isBusy;
    });
  };

  const cartErrorMessage = (error) => {
    if (!error) return 'We could not update your cart. Please try again.';
    if (typeof error.description === 'string') return error.description;
    if (typeof error.message === 'string') return error.message;
    return 'We could not update your cart. Please try again.';
  };

  const updateCartCounts = (cart) => {
    const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    document.querySelectorAll('[data-fd-cart-count], .cart-link__bubble-num').forEach((node) => {
      node.textContent = count;
      node.hidden = count === 0;
    });
    document.querySelectorAll('.fd-cart-dot, .cart-link__bubble').forEach((node) => {
      node.hidden = count === 0;
      node.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  };

  const renderMiniCart = (cart) => {
    if (!miniCartContent || !cart) return;
    updateCartCounts(cart);

    if (!cart.item_count) {
      miniCartContent.innerHTML = `
        <div class="fd-cart-panel__empty">
          <strong>Your cart is empty.</strong>
          <p>Start with fabric swatches or browse custom window treatments.</p>
        </div>
        <nav>
          <a href="/collections/linen-curtains-booklets">Order Free Swatches</a>
          <a href="/collections/linen-curtains">Shop Drapery</a>
          <a href="/collections/roman-shades-1">Shop Roman Shades</a>
          <a href="/collections/bamboo-roman-shade">Shop Bamboo Shades</a>
        </nav>
      `;
      return;
    }

    const visibleItems = cart.items.slice(0, 6);
    const itemsMarkup = visibleItems.map((item) => {
      const title = escapeHtml(item.product_title || item.title);
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<span>${escapeHtml(item.variant_title)}</span>`
        : '';
      const image = item.image || (item.featured_image && item.featured_image.url) || '';
      const imageMarkup = image
        ? `<img src="${escapeHtml(image)}" alt="${title}" width="80" height="80" loading="lazy">`
        : '<span class="fd-cart-panel__placeholder" aria-hidden="true"></span>';

      return `
        <div class="fd-cart-panel__item" data-fd-cart-panel-item data-fd-cart-panel-key="${escapeHtml(item.key)}">
          ${imageMarkup}
          <div>
            <a href="${escapeHtml(item.url || '/cart')}">${title}</a>
            ${variant}
            <div class="fd-cart-panel__qty">
              <button type="button" data-fd-cart-panel-action="decrease" aria-label="Decrease ${title} quantity">-</button>
              <input type="number" value="${item.quantity}" min="0" inputmode="numeric" data-fd-cart-panel-input aria-label="${title} quantity">
              <button type="button" data-fd-cart-panel-action="increase" aria-label="Increase ${title} quantity">+</button>
              <button class="fd-cart-panel__remove" type="button" data-fd-cart-panel-action="remove">Remove</button>
            </div>
            <strong>${formatMoney(item.final_line_price)}</strong>
          </div>
        </div>
      `;
    }).join('');

    const extraItems = cart.items.length > visibleItems.length
      ? `<p class="fd-cart-panel__more">${cart.items.length - visibleItems.length} more item${cart.items.length - visibleItems.length > 1 ? 's' : ''} in your cart.</p>`
      : '';

    miniCartContent.innerHTML = `
      <div class="fd-cart-panel__items" data-fd-mini-cart-items>${itemsMarkup}</div>
      ${extraItems}
      <div class="fd-cart-panel__subtotal">
        <span>Subtotal</span>
        <strong data-fd-mini-cart-subtotal>${formatMoney(cart.total_price)}</strong>
      </div>
      <ul class="fd-cart-panel__assurance" aria-label="Checkout reassurance">
        <li>Secure checkout</li>
        <li>Free U.S. shipping over $300</li>
        <li>Measuring help before ordering</li>
      </ul>
      <div class="fd-header-panel__actions">
        <a class="fd-btn fd-btn--ghost" href="/cart">View Cart</a>
        <form class="fd-cart-panel__checkout" action="${escapeHtml(route('cartPage', '/cart'))}" method="post">
          <input type="hidden" name="checkout" value="Checkout">
          <button class="fd-btn" type="submit" name="checkout">Checkout</button>
        </form>
      </div>
      <p class="fd-cart-panel__notice">Shipping, taxes, and custom-order timing are calculated at checkout. Custom window treatments cannot ship to P.O. boxes.</p>
    `;
  };

  const updateCartPage = (cart) => {
    const page = document.querySelector('[data-fd-cart-page]');
    if (!page || !cart) return;

    if (!cart.item_count) {
      window.location.reload();
      return;
    }

    const byKey = new Map(cart.items.map((item) => [item.key, item]));
    page.querySelectorAll('[data-fd-cart-item]').forEach((itemNode) => {
      const item = byKey.get(itemNode.dataset.fdCartKey);
      if (!item) {
        itemNode.remove();
        return;
      }

      const input = itemNode.querySelector('[data-fd-cart-input]');
      const linePrice = itemNode.querySelector('[data-fd-cart-line-price]');
      if (input) input.value = item.quantity;
      if (linePrice) linePrice.innerHTML = formatMoney(item.final_line_price);
    });

    const subtotal = page.querySelector('[data-fd-cart-subtotal]');
    if (subtotal) subtotal.innerHTML = formatMoney(cart.total_price);
  };

  const refreshCart = () => getCart().then((cart) => {
    renderMiniCart(cart);
    updateCartPage(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return cart;
  });

  const updateCartQuantity = (key, quantity, scope) => {
    if (!key) return Promise.resolve();
    setBusy(scope, true);
    return changeCartItem(key, quantity)
      .then((cart) => {
        renderMiniCart(cart);
        updateCartPage(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        return cart;
      })
      .catch((error) => {
        alert(cartErrorMessage(error));
        throw error;
      })
      .finally(() => setBusy(scope, false));
  };

  const closePanels = () => {
    header.querySelectorAll('.fd-header-panel, .fd-mobile-menu').forEach((panel) => {
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
    });
    header.querySelectorAll('[data-fd-toggle]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  };

  const openCartPanel = () => {
    const panel = document.getElementById('FdCartPanel');
    if (!panel) return;
    closePanels();
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    header.querySelectorAll('[aria-controls="FdCartPanel"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'true');
    });
  };

  header.addEventListener('click', (event) => {
    const target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    const panelAction = target.closest('[data-fd-cart-panel-action]');
    if (panelAction) {
      event.preventDefault();
      const item = panelAction.closest('[data-fd-cart-panel-item]');
      const input = item ? item.querySelector('[data-fd-cart-panel-input]') : null;
      const currentQuantity = input ? parseInt(input.value, 10) || 0 : 0;
      const action = panelAction.dataset.fdCartPanelAction;
      const nextQuantity = action === 'increase'
        ? currentQuantity + 1
        : action === 'decrease'
          ? Math.max(currentQuantity - 1, 0)
          : 0;

      updateCartQuantity(item && item.dataset.fdCartPanelKey, nextQuantity, item)
        .catch(() => refreshCart().catch(() => {}));
      return;
    }

    const toggle = target.closest('[data-fd-toggle]');
    const close = target.closest('[data-fd-close]');

    if (close) {
      closePanels();
      return;
    }

    if (!toggle) return;

    event.preventDefault();
    const targetId = toggle.getAttribute('aria-controls') || `Fd${toggle.dataset.fdToggle}`;
    const panel = document.getElementById(targetId);
    if (!panel) return;

    const willOpen = panel.hidden;
    closePanels();
    panel.hidden = !willOpen;
    panel.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

    if (willOpen && targetId === 'FdCartPanel') {
      refreshCart().catch(() => {});
    }
  });

  header.addEventListener('change', (event) => {
    const input = event.target && event.target.closest ? event.target.closest('[data-fd-cart-panel-input]') : null;
    if (!input) return;
    const item = input.closest('[data-fd-cart-panel-item]');
    updateCartQuantity(item && item.dataset.fdCartPanelKey, input.value, item)
      .catch(() => refreshCart().catch(() => {}));
  });

  document.addEventListener('click', (event) => {
    handleBcpoCheckoutClick(event);

    const actionButton = event.target && event.target.closest ? event.target.closest('[data-fd-cart-action]') : null;
    if (!actionButton) return;

    const item = actionButton.closest('[data-fd-cart-item]');
    if (!item) return;

    event.preventDefault();
    const input = item.querySelector('[data-fd-cart-input]');
    const currentQuantity = input ? parseInt(input.value, 10) || 0 : 0;
    const action = actionButton.dataset.fdCartAction;
    const nextQuantity = action === 'increase'
      ? currentQuantity + 1
      : action === 'decrease'
        ? Math.max(currentQuantity - 1, 0)
        : 0;

    updateCartQuantity(item.dataset.fdCartKey, nextQuantity, item)
      .catch(() => refreshCart().catch(() => {}));
  });

  document.addEventListener('change', (event) => {
    const input = event.target && event.target.closest ? event.target.closest('[data-fd-cart-input]') : null;
    if (!input) return;
    const item = input.closest('[data-fd-cart-item]');
    if (!item) return;
    updateCartQuantity(item.dataset.fdCartKey, input.value, item)
      .catch(() => refreshCart().catch(() => {}));
  });

  document.addEventListener('submit', (event) => {
    if (handleBcpoCheckoutClick(event)) return;

    const form = event.target && event.target.closest ? event.target.closest('.fd-pdp-form') : null;
    if (!form) return;

    const submit = form.querySelector('[data-fd-atc]');
    if (!submit || submit.disabled) return;

    const formData = new FormData(form);
    if (!formData.get('id')) return;

    event.preventDefault();

    const label = form.querySelector('[data-fd-atc-text]');
    const originalLabel = label ? label.textContent : '';
    const existingError = form.querySelector('.errors');
    if (existingError) existingError.remove();

    submit.disabled = true;
    submit.classList.add('is-loading');
    if (label) label.textContent = 'Adding...';

    fetch(route('cartAdd', '/cart/add.js'), {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(readJson)
      .then(() => refreshCart())
      .then(() => {
        openCartPanel();
        if (label) label.textContent = 'Added';
        window.setTimeout(() => {
          if (label) label.textContent = originalLabel || 'Add to Cart';
        }, 1200);
      })
      .catch((error) => {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'errors text-center';
        errorDiv.textContent = cartErrorMessage(error);
        form.append(errorDiv);
        if (label) label.textContent = originalLabel || 'Add to Cart';
      })
      .finally(() => {
        submit.disabled = false;
        submit.classList.remove('is-loading');
      });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanels();
  });

  document.addEventListener('click', (event) => {
    const cookieClose = event.target && event.target.closest ? event.target.closest('[data-fd-cookie-close]') : null;
    if (cookieClose) {
      const choice = (cookieClose.textContent || 'dismissed').trim().toLowerCase().replace(/\s+/g, '-');
      storeCookieConsent(choice);
      hideCookieBars();
      return;
    }

    if (header.contains(event.target)) return;
    closePanels();
  });

  refreshCart().catch(() => {});
})();

(function () {
  const replacements = [
    [/business days \./g, 'business days.'],
    [/support@fredesigner\.com \./g, 'support@fredesigner.com.'],
    [/\?Beautifully Customized!/g, 'Beautifully Customized!'],
    [/\?Good quality/g, 'Good quality']
  ];

  const cleanTextNode = (node) => {
    let nextValue = node.nodeValue;
    replacements.forEach(([pattern, value]) => {
      nextValue = nextValue.replace(pattern, value);
    });
    if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
  };

  const cleanVisibleText = (root) => {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches('script, style, textarea, input')) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.nodeValue && node.nodeValue.trim()
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(cleanTextNode);
  };

  const runTextCleanup = () => cleanVisibleText(document.body);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runTextCleanup, { once: true });
  } else {
    runTextCleanup();
  }

  const textObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) cleanTextNode(node);
        if (node.nodeType === Node.ELEMENT_NODE) cleanVisibleText(node);
      });
    });
  });

  if (document.body) {
    textObserver.observe(document.body, { childList: true, subtree: true });
  }
})();

(function () {
  const lazyVideos = Array.from(document.querySelectorAll('[data-fd-lazy-footer-video]'));
  if (!lazyVideos.length) return;

  const pauseOtherVideos = (activeVideo) => {
    lazyVideos.forEach((video) => {
      if (video !== activeVideo) video.pause();
    });
  };

  const playWhenReady = (video) => {
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const loadVideo = (video) => {
    if (!video || video.dataset.fdVideoLoaded === 'true') return;
    const src = video.dataset.fdVideoSrc;
    if (!src) return;

    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.append(source);
    video.dataset.fdVideoLoaded = 'true';
    video.preload = 'metadata';
    video.load();
  };

  const previewVideo = (video) => {
    if (!video) return;
    pauseOtherVideos(video);
    loadVideo(video);

    if (video.readyState >= 2) {
      playWhenReady(video);
      return;
    }

    video.addEventListener('canplay', () => playWhenReady(video), { once: true });
  };

  lazyVideos.forEach((video) => {
    const media = video.closest('.fd-footer-reel-card__media') || video;
    const onIntent = () => previewVideo(video);

    media.addEventListener('pointerenter', onIntent, { passive: true });
    media.addEventListener('touchstart', onIntent, { passive: true });
    media.addEventListener('focusin', onIntent);
  });

  if ('IntersectionObserver' in window) {
    const pauseWhenAway = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) entry.target.pause();
      });
    }, { rootMargin: '120px 0px' });

    lazyVideos.forEach((video) => pauseWhenAway.observe(video));
  }
})();

(function () {
  const initOfferWidget = () => {
  if (window.__fdOfferWidgetReady) return;
  const widget = document.querySelector('[data-fd-offer-widget]');
  const modal = document.querySelector('[data-fd-offer-modal]');
  if (!widget || !modal) return;
  window.__fdOfferWidgetReady = true;

  const dismissedKey = 'fdOfferWidgetDismissed';
  const openButtons = document.querySelectorAll('[data-fd-offer-open]');
  const closeButtons = document.querySelectorAll('[data-fd-offer-close]');
  const dismissButtons = document.querySelectorAll('[data-fd-offer-dismiss]');
  const feedback = modal.querySelector('[data-fd-offer-feedback]');

  const setModalOpen = (isOpen) => {
    modal.hidden = !isOpen;
    modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.classList.toggle('fd-offer-modal-open', isOpen);

    if (isOpen) {
      const closeButton = modal.querySelector('[data-fd-offer-close]');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }
  };

  const canUseSessionStorage = () => {
    try {
      const key = '__fd_offer_test__';
      window.sessionStorage.setItem(key, '1');
      window.sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      return false;
    }
  };

  const sessionStorageReady = canUseSessionStorage();
  if (sessionStorageReady && window.sessionStorage.getItem(dismissedKey) === 'true') {
    widget.hidden = true;
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', () => setModalOpen(true));
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => setModalOpen(false));
  });

  dismissButtons.forEach((button) => {
    button.addEventListener('click', () => {
      widget.hidden = true;
      if (sessionStorageReady) window.sessionStorage.setItem(dismissedKey, 'true');
      setModalOpen(false);
    });
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) setModalOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) setModalOpen(false);
  });

  document.addEventListener('click', (event) => {
    const copyButton = event.target && event.target.closest ? event.target.closest('[data-fd-copy]') : null;
    if (!copyButton) return;

    const code = copyButton.dataset.fdCopy || '';
    const originalLabel = copyButton.dataset.fdCopyLabel || (copyButton.textContent || '').trim();
    const originalHtml = copyButton.innerHTML;
    const setCopied = () => {
      copyButton.textContent = 'Copied';
      window.setTimeout(() => {
        if (originalLabel) {
          copyButton.textContent = originalLabel;
        } else {
          copyButton.innerHTML = originalHtml;
        }
      }, 1400);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(setCopied).catch(() => {
        window.prompt('Copy discount code', code);
      });
      return;
    }

    window.prompt('Copy discount code', code);
  });

  if (feedback) {
    setModalOpen(true);
  }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOfferWidget, { once: true });
  } else {
    initOfferWidget();
  }
})();
